import { useMemo } from "react"
import { appConstants } from "../../appConstants"
import { BSBuildingResult, bsBuildingResultFromDto } from "../../dto/beem-shot/BSBuildingResult/BSBuildingResult"
import { BiosourceeLevel } from "../../dto/BiosourceLevel/BiosourceLevel"
import { useHttp } from "../use-http"

interface BSDashboardHook {
  getBSBuildingResult(bsBuildingId: string): Promise<BSBuildingResult | undefined>

  getBiosourceThresholds(usage: string): Promise<any>
}

export function useBSDashboard(): BSDashboardHook {
  const { get } = useHttp()

  return useMemo(
    () => ({
      getBSBuildingResult(bsBuildingId: string): Promise<BSBuildingResult | undefined> {
        return get(appConstants.apiEndpoints.BEEM_SHOT_DASHBOARD_BUILDING_RESULT, [
          { key: "bsBuildingId", value: bsBuildingId },
        ])
          .then((response) => {
            if (response.status === 404) {
              return Promise.resolve(undefined)
            } else {
              return response.json()
            }
          })
          .then((data) => bsBuildingResultFromDto(data))
      },

      getBiosourceThresholds(usage: string): Promise<BiosourceeLevel> {
        return get(appConstants.apiEndpoints.BEEM_SHOT_DASHBOARD_BIOSOURCE_THRESHOLDS, [
          { key: "usage", value: usage },
        ]).then((response) => response.json())
      },
    }),
    [get]
  )
}
